import { useQuery } from '@tanstack/react-query';
import { useApiV2 } from '@/shared/api';
import type { AgreementCode } from '@/shared/data-types';
import { agreementQueryOptions } from './agreement.query-options';

/** 약관 query — code(terms·privacy·refund) 별 본문 조회. v2 agreement 도메인. */
export function useAgreementQuery(code: AgreementCode) {
  const api = useApiV2();
  return useQuery(agreementQueryOptions(api, code));
}
